import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IModelSeriesMapping } from 'next-common';

interface ModelSeriesMappingState {
  modelSeriesMapping: IModelSeriesMapping[];
}

const initialState: ModelSeriesMappingState = {
  modelSeriesMapping: [],
};

const modelSeriesMappingSlice = createSlice({
  name: 'modelSeriesMapping',
  initialState,
  reducers: {
    setModelSeriesMapping: (state, action: PayloadAction<IModelSeriesMapping[]>) => {
      state.modelSeriesMapping = action.payload;
    },
  },
});

export const { setModelSeriesMapping } = modelSeriesMappingSlice.actions;
export default modelSeriesMappingSlice.reducer;
